// Darstellung der Plandaten aus GET /api/payments/plans (AUD-61).
//
// Das Frontend hält bewusst keine Preise vor — hier steht nur, wie ein vom Backend
// gelieferter Preis auf Deutsch formatiert wird (de-DE, Nettopreise „zzgl. USt.").

const INTERVAL_LABEL = {
  month: { one: 'Monat', many: 'Monate' },
  year: { one: 'Jahr', many: 'Jahre' },
  week: { one: 'Woche', many: 'Wochen' },
  day: { one: 'Tag', many: 'Tage' },
};

// „49 €" / „0 €" — ohne Nachkommastellen bei glatten Beträgen, sonst „49,50 €".
export function formatPlanPrice(price) {
  if (!price || typeof price.amount !== 'number') return null;
  const value = price.amount / 100;
  const hasCents = value % 1 !== 0;
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: (price.currency || 'eur').toUpperCase(),
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: hasCents ? 2 : 0,
  }).format(value);
}

// „Monat" bzw. „3 Monate" — null bei Plänen ohne Abrechnungsintervall (Free).
export function formatPlanInterval(price) {
  if (!price || !price.interval) return null;
  const label = INTERVAL_LABEL[price.interval];
  if (!label) return null;
  const count = price.intervalCount || 1;
  return count > 1 ? `${count} ${label.many}` : label.one;
}

// Zusatz hinter dem Preis: „/ Monat zzgl. USt." bzw. „dauerhaft, ohne Zahlungsdaten".
export function formatPriceSuffix(price) {
  const interval = formatPlanInterval(price);
  return interval ? `/ ${interval} zzgl. USt.` : 'dauerhaft, ohne Zahlungsdaten';
}
